import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from "@/src/components/ui/button"
import { useEffect, useState } from "react"
import { authClient } from "@/src/lib/auth-client"
import { useTranslation } from "@/src/i18n/client"

export const Route = createFileRoute('/_auth/verify-email')({
  component: VerifyEmailPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: (search.token as string) || '',
    }
  },
})

function VerifyEmailPage() {
  const { t } = useTranslation('auth')
  const { token } = Route.useSearch()
  const [status, setStatus] = useState<'pending' | 'success' | 'error' | 'idle'>('idle')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (token) {
      setStatus('pending')
      authClient.verifyEmail({ 
        query: { token } 
      })
        .then((result) => {
          if (result.error) {
            setStatus('error')
            setMessage(result.error.message || t('verifyEmail.errorVerification'))
          } else {
            setStatus('success')
            setMessage(t('verifyEmail.successMessage'))
          }
        })
        .catch((error) => {
          setStatus('error')
          setMessage(error.message || t('verifyEmail.errorVerification'))
        })
    }
  }, [token, t])

  return (
    <div className="text-center">
      <h2 className="mb-4 text-2xl font-bold text-foreground">{t('verifyEmail.title')}</h2>
      {status === 'pending' && <p className="text-muted-foreground mb-6">{t('verifyEmail.verifying')}</p>}
      {status === 'success' && <p className="text-green-600 mb-6">{message}</p>}
      {status === 'error' && <p className="text-red-600 mb-6">{message}</p>}
      {status === 'idle' && <p className="text-muted-foreground mb-6">{t('verifyEmail.idleMessage')}</p>}
      <Button nativeButton={false} className="bg-primary text-primary-foreground hover:bg-primary/90" render={<Link to="/login" />}>
        {t('verifyEmail.backToLogin')}
      </Button>
    </div>
  )
}
